import merge from 'lodash/merge'

export default {
  settings: (state) => { return state.settings },
  type: (state) => { return state.settings.configuration.type },
  configurationSettings: (state) => {
    return state.settings.configuration
  },
  initialLoadGate: (state) => { return state.settings.configuration.initialLoadGate },
  accountActivationStatus: (state) => state.activationStatus,
  configSettings: (state, getters) => (payload) => {
    const settingsExist = Object.keys(state.settings).includes(payload)

    return (settingsExist) ? state.settings[payload].configuration || {} : getters.defaults(payload).configuration
  },
  contentSettings: (state, getters) => (payload) => {
    const settingsExist = Object.keys(state.settings).includes(payload)

    return (settingsExist) ? state.settings[payload].content || {} : getters.defaults(payload).content
  },
  styleSettings: (state, getters) => (payload) => {
    const settingsExist = Object.keys(state.settings).includes(payload)
    const defaults = getters.defaults(payload).styles

    return (settingsExist) ? merge({}, defaults, state.settings[payload].styling) : defaults
  },
  defaults: (state, payload) => (payload) => {
    return {
      styles: (Object.keys(state.defaultSettings).includes(payload)) ? state.defaultSettings[payload].styling || {} : {},
      content: (Object.keys(state.defaultSettings).includes(payload)) ? state.defaultSettings[payload].content || {} : {},
      configuration: (Object.keys(state.defaultSettings).includes(payload)) ? state.defaultSettings[payload].configuration || {} : {}
    }
  },
  settingsTimestamp: (state) => { return state.settings.configuration.timestamp }
}
